"use client";

import { ProductOptionsPane } from "@frontend/components/featuredCarousel/ProductOptionsPane";
import type { GetProductsByCategoryIdQuery } from "@frontend/lib/graphql/generated-gql";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@frontend/shared/components/ui/dialog";
import {
  Drawer,
  DrawerContent,
  DrawerTitle,
} from "@frontend/shared/components/ui/drawer";
import { useMediaQuery } from "usehooks-ts";

interface ProductOptionsContainerProps {
  product: GetProductsByCategoryIdQuery["findManyProducts"][number];
  clientSlug: string;
  orgId: number;
  kioskMode: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ProductOptionsContainer = ({
  product,
  clientSlug,
  orgId,
  kioskMode,
  open,
  onOpenChange,
}: ProductOptionsContainerProps) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  if (isMobile) {
    return (
      <Drawer open={open} onOpenChange={onOpenChange}>
        <DrawerContent className="rounded-t-3xl">
          <DrawerTitle className="sr-only">{product.name} Options</DrawerTitle>
          <ProductOptionsPane
            product={product}
            clientSlug={clientSlug}
            orgId={orgId}
            onOpenChange={onOpenChange}
            kioskMode={kioskMode}
          />
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="w-full max-w-[600px] sm:rounded-3xl [&>button]:hidden"
        onOpenAutoFocus={(e) => e.preventDefault()}
        onCloseAutoFocus={(e) => e.preventDefault()}
      >
        <DialogTitle className="sr-only">{product.name} Options</DialogTitle>
        <ProductOptionsPane
          product={product}
          clientSlug={clientSlug}
          orgId={orgId}
          onOpenChange={onOpenChange}
          kioskMode={kioskMode}
        />
      </DialogContent>
    </Dialog>
  );
};
